module.exports = __webpack_public_path__ + "img/ax.918079f3.svg";